import { $generateNodesFromDOM } from "@lexical/html"
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext"
import { $getRoot, $insertNodes } from "lexical"
import { useEffect } from "react"

export default function SerializeHtmlPlugin({ rawHtml, setJsonTextEditor, setPlainTextEditor }) {
  const [editor] = useLexicalComposerContext()

  useEffect(() => {
    if (!editor) {
      return;
    }

    editor.update(() => {
      const root = $getRoot()
      const textContent = root.getTextContent()

      if (rawHtml && !textContent) {
        try {

          // In the browser you can use the native DOMParser API to parse the HTML string.
        const parser = new DOMParser();
        const dom = parser.parseFromString(rawHtml, "text/html");

         // Check if the parsed DOM is empty or contains only empty elements
         if (!dom.body || dom.body.innerHTML.trim() === "") {
          console.warn("Parsed DOM is empty or contains only empty elements");
          setPlainTextEditor("No content available");
          setJsonTextEditor([]);
          return;
        }

        // Once you have the DOM instance it's easy to generate LexicalNodes.
        const nodes = $generateNodesFromDOM(editor, dom);
        
        // Select the root
        root.select();

        // Insert them at a selection.
        $insertNodes(nodes);

        const updatedTextContent = root.getTextContent()
        setPlainTextEditor(updatedTextContent)

        setJsonTextEditor(nodes)

        } catch (error) {
          console.error("Error during editor update:", error);

          setPlainTextEditor("Error loading content");
          setJsonTextEditor([])
        }
      }
    })
  }, [editor, rawHtml, setJsonTextEditor, setPlainTextEditor])

  return null
}